import styled from 'styled-components';
import TextButton from '../../atoms/TextButton';
import IconButton from '../../atoms/IconButton';

import {
	ChevronDownIcon,
	ChevronUpIcon,
} from '../../atoms/Icons';
import {
	DividerColor, 
	Grey500, 
	Grey600,
	Grey800,
	AccentColor,
	ScoreColor,
} from '../../Colors';
const defaultStyle = {
	Wrapper : styled.div`
        padding : 1rem;
    `,
	Scores : styled.div`
        color : ${Grey500};
        padding : 1rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align : left;
    `,
	ScoreColor : styled.span`
        color : ${({avg})=>{
		return ScoreColor(avg);
	}};
    `,
	AvgScores : styled.div`
    color : ${Grey500};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align : right;
    `,
	LastUpdate : styled.div`
        padding-right : 1rem;
        padding-bottom : 0.5rem;
        color : ${Grey500};
        text-align : right;
    `,
	ShowMoreScore : styled.div`
        color : ${AccentColor};
    `,
	ChevronDownIcon : styled(ChevronDownIcon)`
        margin-right : 1rem;
    `,
	ChevronUpIcon : styled(ChevronUpIcon)`
        margin-right : 1rem;
    `,
	ShowMoreButton : styled(TextButton)`
    `,
	IconButton : styled(IconButton)`
        color : ${Grey600};
        font-size : 2rem;
        margin-right : 2rem;
    `,
	ScoreSpan : styled.span`
        margin-left : 1rem;
    `,
	ScoreTable : styled.div`
        background-color : transparent;
        padding : 3rem;
        & > table {
            border-collapse: collapse;
            width : 100%;
            color : ${Grey800};
        }
        & > table,th {
            border-bottom:1px ${DividerColor} solid;
        }
    `,
	NoScore : styled.div`
        font-size : 2rem;
        display : flex;
        justify-content : center;
        align-items : center;
        padding : 1rem;
        min-height : 40vh;
        color : ${Grey500};
    `
};

export default defaultStyle;